<svg fill="none" height="24" viewBox="0 0 21 24" width="21" xmlns="http://www.w3.org/2000/svg">
	<path
		clip-rule="evenodd"
		d="M19.3168 8.3842L18.5274 7.6448L10.497 0L2.4681 7.64335L1.67868 8.38275C-0.55956 10.4792 -0.55956 13.8891 1.67868 16.0261C2.77613 17.054 4.2234 17.5875 5.67222 17.5875C7.16438 17.5875 8.61166 17.054 9.70911 16.0261L10.4985 15.2447L11.2879 16.0261C12.4287 17.054 13.876 17.5875 15.3248 17.5875C16.7721 17.5875 18.2209 17.054 19.3617 16.0261C21.5535 13.8905 21.5535 10.4792 19.3168 8.3842ZM14.3141 20.3842L10.5403 16.7669L6.72324 20.3842L10.5403 24L14.3141 20.3842ZM14.9286 11.0547L14.5339 11.4244L10.497 15.2461L6.4601 11.4244L6.06539 11.0547C4.96794 9.98623 4.96794 8.25951 6.06539 7.19101C6.63656 6.69808 7.33775 6.41102 8.08383 6.41102C8.82991 6.41102 9.5311 6.69808 10.1023 7.19246L10.497 7.60275L10.8917 7.19246C11.4629 6.69953 12.2074 6.41102 12.9535 6.41102C13.6562 6.41102 14.4007 6.69808 14.9719 7.19246C16.026 8.26096 16.026 9.98623 14.9286 11.0547Z"
		fill="url(#paint0_linear_158_63046)"
		fill-rule="evenodd"
	/>
	<defs>
		<linearGradient
			gradientUnits="userSpaceOnUse"
			id="paint0_linear_158_63046"
			x1="10.5929"
			x2="10.5929"
			y1="0.9"
			y2="24"
		>
			<stop stop-color="#3EFFB4" />
			<stop offset="1" stop-color="#01D180" />
		</linearGradient>
	</defs>
</svg>
